module.exports = __webpack_public_path__ + "img/about.dd90bebb.jpg";